/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import DashboardIcon from '@material-ui/icons/DashboardOutlined';
import ListAltIcon from '@material-ui/icons/ListAlt';
import ReceiptIcon from '@material-ui/icons/ReceiptOutlined';
import DescriptionIcon from '@material-ui/icons/Description';
import { authRoles } from 'services/auth';

export default [
  {
    title: 'Pages',
    pages: [
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: DashboardIcon,
        auth: authRoles.all
      },
      {
        title: 'Charge',
        href: '/charge',
        icon: ReceiptIcon,
        auth: authRoles.all
      },
      // {
      //   title: 'Transfer',
      //   href: '/transfer',
      //   icon: ListAltIcon,
      //   auth: authRoles.all
      // },
      {
        title: 'Billing',
        href: '/billing',
        icon: DescriptionIcon,
        auth: authRoles.staff
      }
    ]
  }
];
